import React from 'react';
import { Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { colorsModeUI } from '../modeUI';
import {
  TYPE_POSITIVE,
  TYPE_NEGATIVE,
  TYPE_WARNING,
  TYPE_DISABLED,
} from '../constants';
import './index.css';

/**
 * Box main sensor nuttall
 * Display box with the main sensor data (value, unit, titlevalue and titleAlarm )
 * parameters (props)
 * @param string value
 * @param string titleValue
 * @param string unitValue
 * @param string type
 * @param string mode
 * @param function onClick
 * @param string titleAlarm
 */
export default class BoxMainSensorNuttall extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.state = {
      clickable: !!props.onClick,
    };
  }

  onClick(event, data) {
    const { onClick } = this.props;
    if (onClick) {
      onClick(event, data);
    }
  }

  render() {
    const { clickable } = this.state;

    const containerProps = {};
    if (clickable) {
      containerProps.onClick = this.onClick;
    }

    const { value, titleValue, unitValue, type, mode, titleAlarm } = this.props;

    const styleContainer = {};
    const styleValue = {};
    const styleTitle = {};
    /* mode UI: dark mode/light mode */
    if (mode !== null) {
      const modeColors = colorsModeUI(mode);
      styleContainer.color = modeColors.BOX_MAIN_SENSOR_COLOR;
      styleTitle.color = modeColors.PRIMARY_COLOR;
      switch (type) {
        case TYPE_POSITIVE:
          styleValue.color = modeColors.BOX_MAIN_SENSOR_COLOR;
          break;
        case TYPE_WARNING:
          styleValue.color = modeColors.WARNING_COLOR;
          break;
        case TYPE_NEGATIVE:
          styleValue.color = modeColors.ALARM_COLOR;
          break;
        case TYPE_DISABLED:
          styleValue.color = modeColors.DISABLE_COLOR;
          break;
        default:
          styleValue.color = modeColors.BOX_MAIN_SENSOR_COLOR;
      }
    }

    return (
      <div
        className={`box-main-sensor-nuttall${clickable ? ' clickable' : ''}`}
        style={styleContainer}
        {...containerProps}
      >
        <div className="title" style={styleTitle}>
          {titleValue}
        </div>
        <div className="value-unit">
          <div className="unit" style={styleValue}>
            {unitValue}
          </div>
          <div className="value" style={styleValue}>
            {value}
          </div>
          {titleAlarm && (
            <div className="title-alarm" style={styleValue}>
              <Icon name="warning sign" size="small" key="alarms" />
              {titleAlarm}
            </div>
          )}
        </div>
      </div>
    );
  }
}

BoxMainSensorNuttall.propTypes = {
  value: PropTypes.string.isRequired,
  titleValue: PropTypes.string,
  unitValue: PropTypes.string,
  type: PropTypes.string,
  mode: PropTypes.string,
  onClick: PropTypes.func,
  titleAlarm: PropTypes.string,
};

BoxMainSensorNuttall.defaultProps = {
  titleValue: null,
  unitValue: null,
  mode: null,
  type: TYPE_POSITIVE,
  onClick: null,
  titleAlarm: null,
};
